import { fetchPortalFmoOnboardingStatus, getPortalSettings, updatePortalFmoOnboardingStatus } from '../api/portalSettingsApi';
import { FETCH_PORTAL_SETTINGS_SUCCEEDED, FETCH_PORTAL_SETTINGS_STARTED, FETCH_PORTAL_HAS_SEEN_FMO_ONBOARDING_STARTED, FETCH_PORTAL_HAS_SEEN_FMO_ONBOARDING_SUCCEEDED, SET_HAS_PORTAL_SEEN_FMO_ONBOARDING_MODAL } from '../actions/ActionTypes';
import { logRavenException } from 'ui-deal-management-components-lib/utils/ravenWrapperUtil';
export function fetchPortalSettings() {
  return dispatch => {
    dispatch({
      type: FETCH_PORTAL_SETTINGS_STARTED
    });
    return getPortalSettings().then(settings => {
      dispatch({
        type: FETCH_PORTAL_SETTINGS_SUCCEEDED,
        payload: settings
      });
    });
  };
}
export function fetchHasPortalSeenFmoAdminOnboarding() {
  return dispatch => {
    dispatch({
      type: FETCH_PORTAL_HAS_SEEN_FMO_ONBOARDING_STARTED
    });
    return fetchPortalFmoOnboardingStatus().then(data => {
      dispatch({
        type: FETCH_PORTAL_HAS_SEEN_FMO_ONBOARDING_SUCCEEDED,
        payload: data
      });
      return data;
    }).catch(error => logRavenException(error, 'fetchHasPortalSeenFmoAdminOnboarding'));
  };
}
export function setHasPortalSeenFmoAdminOnboarding() {
  return dispatch => {
    return updatePortalFmoOnboardingStatus(true).then(() => {
      dispatch({
        type: SET_HAS_PORTAL_SEEN_FMO_ONBOARDING_MODAL,
        payload: true
      });
    }).catch(error => logRavenException(error, 'setHasPortalSeenFmoAdminOnboarding'));
  };
}